const brandName = "rumnwillow";
const locale = "en-GB";
const businessCountry = {
  name: "United Kingdom",
  code: "GB",
};

const seo = {
  title: "rumnwillow · Botanical Haircare & Bodycare",
  description:
    "Discover thoughtful botanical hair and body care from rumnwillow in the United Kingdom.",
};

const routeSeo = {
  "/": seo,
  "/about": {
    title: `Our story · ${brandName}`,
    description:
      "Discover the considered formulation and modern care philosophy behind rumnwillow.",
  },
  "/cartpage": {
    title: `Your bag · ${brandName}`,
    description: "Review your selected plant-powered rituals before checkout.",
  },
  "/checkout": {
    title: `Secure checkout · ${brandName}`,
    description: "Enter delivery details and continue to secure hosted payment.",
  },
  "/contact": {
    title: `Contact customer care · ${brandName}`,
    description: "Contact our customer care team for product, order and ritual guidance.",
  },
  "/paysuccess": {
    title: `Order received · ${brandName}`,
    description: "Review the latest status of your order payment.",
  },
  "/privacy": {
    title: `Privacy policy · ${brandName}`,
    description: "Read how we handle personal information and privacy choices.",
  },
  "/returns": {
    title: `Returns · ${brandName}`,
    description: "Review return eligibility, timing and refund information.",
  },
  "/shipping": {
    title: `Shipping · ${brandName}`,
    description: "Review processing times, delivery options and shipping guidance.",
  },
  "/terms": {
    title: `Terms & conditions · ${brandName}`,
    description: "Read the terms governing use of this storefront.",
  },
  "/faqs": {
    title: `Frequently asked questions · ${brandName}`,
    description: "Find answers about products, orders, shipping, returns and payment.",
  },
  "/cookies": {
    title: `Cookie policy · ${brandName}`,
    description: "Learn how cookies and similar technologies support this store.",
  },
  "/policies": {
    title: `Store policies · ${brandName}`,
    description: "Browse all rumnwillow shopping, privacy, product-care and legal policies.",
  },
  "/payments": {
    title: `Payment & billing policy · ${brandName}`,
    description: "Review payment methods, billing, authorization, security and refund information.",
  },
  "/orders": {
    title: `Order & cancellation policy · ${brandName}`,
    description: "Review order acceptance, changes, cancellations, availability and order limits.",
  },
  "/product-safety": {
    title: `Product information & safety · ${brandName}`,
    description: "Read guidance about labels, ingredients, safe product use and storage.",
  },
  "/quality-guarantee": {
    title: `Quality guarantee policy · ${brandName}`,
    description: "Learn how we review damaged, incorrect, defective or potentially unsafe products.",
  },
  "/promotions": {
    title: `Promotions & discount policy · ${brandName}`,
    description: "Review the rules for discount codes, offers, gifts and promotional returns.",
  },
  "/data-rights": {
    title: `Data rights & requests · ${brandName}`,
    description: "Learn how to submit access, correction, deletion and other privacy requests.",
  },
  "/communications": {
    title: `Communications policy · ${brandName}`,
    description: "Learn about order messages, optional marketing and unsubscribe choices.",
  },
  "/security": {
    title: `Security & fraud policy · ${brandName}`,
    description: "Read about payment safety, fraud checks, suspicious messages and reporting.",
  },
  "/accessibility": {
    title: `Accessibility statement · ${brandName}`,
    description: "Read our accessibility approach and how to request shopping assistance.",
  },
  "/intellectual-property": {
    title: `Intellectual property policy · ${brandName}`,
    description: "Review permitted content use, brand rights and rights-notice procedures.",
  },
  "/sustainability": {
    title: `Sustainability & packaging · ${brandName}`,
    description: "Read how we communicate environmental and packaging information.",
  },
  "/complaints": {
    title: `Complaints & resolution policy · ${brandName}`,
    description: "Learn how to raise, review and escalate a customer concern.",
  },
  "/payment": {
    title: `Payment status · ${brandName}`,
    description: "Review the status of your rumnwillow payment.",
  },
};

const siteConfig = {
  brandName,
  logo: {
    type: "image",
    src: "/head/rumnwillow-wordmark.svg",
    mark: "/head/rumnwillow-mark.svg",
  },
  tagline: "Botanical care, considered daily",
  description:
    "Thoughtful hair and body care made with effective botanicals, balanced textures and a less-is-more approach to everyday routines.",
  locale,
  language: "English",
  businessCountry,
  announcement:
    "Tracked delivery $9.99 · Easy 30-day returns",
  currency: "USD",
  currencySymbol: "$",
  shippingFlatRate: 9.99,
  contact: {
    email: "order@rumnwillow.online",
    address: null,
    addressStatus: "Not currently available",
    country: businessCountry.name,
    countryCode: businessCountry.code,
    hours: "Monday–Friday, 9am–6pm UK time",
  },
  policies: {
    returnWindow: 30,
    dispatchTime: "1–2 business days",
    lastUpdated: "October 26, 2026",
  },
  navigation: [
    { label: "Shop All", path: "/shop" },
    { label: "Best Sellers", path: "/shop?collection=best-sellers" },
    { label: "Shampoo + Conditioner", path: "/shop?search=shampoo" },
    { label: "Treatments", path: "/shop?search=treatment" },
    { label: "Body Care", path: "/shop?search=body" },
    { label: "About", path: "/about" },
  ],
  seo,
  routeSeo,
  structuredData: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: brandName,
    email: "order@rumnwillow.online",
    address: {
      "@type": "PostalAddress",
      addressCountry: businessCountry.code,
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "order@rumnwillow.online",
      availableLanguage: "English",
    },
  },
  copyright: `© ${new Date().getFullYear()} ${brandName}. All rights reserved.`,
};

export default siteConfig;
